import { render, staticRenderFns } from "./pullRequests.vue?vue&type=template&id=1e8adb52&"
import script from "./pullRequests.vue?vue&type=script&lang=js&"
export * from "./pullRequests.vue?vue&type=script&lang=js&"
import style0 from "./pullRequests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports